(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('autoFocus', autoFocus);

    autoFocus.$inject = ['$timeout'];

    function autoFocus($timeout) {
        return {
            restrict: 'A',
            scope: {autoFocus: '='},
            link: function (scope, element, attr) {

                scope.$watch('autoFocus', focus);

                function focus(value) {
                    if (value === true) {
                        element[0].focus();
                    }
                }

            }
        }
    }

})();